import { createRouter, createWebHistory } from "vue-router";
import authRoutes from "./authRoutes";
import dashboardRoutes from "./dashboardRoutes";
// dynamic inport routes
import subscriberRoutes from "./subscriberRoutes";
import pushManagementRoutes from "./pushManagementRoutes";
import ratePlanRoutes from "./ratePlanRoutes";
import feedBackRoutes from "./feedBackRoutes";
import hourlySubscriptionReportRoutes from "./hourlySubscriptionReportRoutes";
import onlineTransactionReportRoutes from "./onlineTransactionReportRoutes";
import subscriberSubscriptionReportRoutes from "./subscriberSubscriptionReportRoutes";
import inappAndroidRoutes from "./inappAndroidRoutes";
import inappIOSRoutes from "./inappIOSRoutes";
import stripePaymentRoutes from "./stripePaymentRoutes";
import paypalPaymentRoutes from "./paypalPaymentRoutes";
import serverListRoutes from "./serverListRoutes";
import ipBundleRoutes from "./ipBundleRoutes";
import ipListRoutes from "./ipListRoutes";
import radiusServerRoutes from "./radiusServerRoutes";

import settingRoutes from "./settingRoutes";
import supportToken from "./supportToken";

const routes = [
  {
    name: "guest",
    path: "/login",
    component: () => import("../components/layouts/Guest.vue"),
    meta: {
      middleware: "guest",
    },
    children: authRoutes,
  },
  {
    name: "base",
    path: "/",
    component: () => import("../components/layouts/Default.vue"),
    meta: {
      middleware: "auth",
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        redirect: { name: "home" },
      },
      ...dashboardRoutes,
      ...subscriberRoutes,
      ...pushManagementRoutes,
      ...ratePlanRoutes,
      ...feedBackRoutes,
      ...hourlySubscriptionReportRoutes,
      ...onlineTransactionReportRoutes,
      ...subscriberSubscriptionReportRoutes,
      ...inappAndroidRoutes,
      ...inappIOSRoutes,
      ...stripePaymentRoutes,
      ...paypalPaymentRoutes,
      ...serverListRoutes,
      ...ipBundleRoutes,
      ...ipListRoutes,
      ...radiusServerRoutes,
      ...settingRoutes,
      ...supportToken,
    ],
  },
];

const router = createRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("jwt_token") == null) {
      next({
        name: "login",
      });
    } else {
      next();
    }
  } else {
    if (to.name == "login") {
      if (localStorage.getItem("jwt_token") == null) {
        next();
      } else {
        next({
          name: "home",
        });
      }
    } else {
      next();
    }
  }
});

export default router;
